import {
  PaxCheckApplyDocumentError,
  PaxCheckIdMismatches,
  PaxCheckRecognizeDocumentError,
  PaxCheckRulesMismatch,
} from "api/models";

function applyDocumentErrorFromApi(
  err: PaxCheckApplyDocumentError
): [ApplyDocumentError, { [key: string]: any }] {
  switch (err.type) {
    case "id-mismatches":
      return [
        new ApplyDocumentErrorIdMismatch(err),
        {
          id_mismatch_error: 1,
        },
      ];

    case "provide-passport":
      return [new ApplyDocumentErrorProvidePassportFirst(), {}];

    case "rules-mismatches":
      return [
        new ApplyDocumentErrorRulesMismatch(err.mismatches),
        {
          rules_mismatch_error: 1,
        },
      ];

    case "no-items-to-apply-document-to":
      return [new ApplyDocumentErrorNoApplicableItems(), {}];

    case "signals-mismatches":
      return [new ApplyDocumentErrorSignalsMismatch(err.fields), {}];

    default:
      throw new Error(`Unexpected error type: ${(err as any).type}`);
  }
}

type ApplyDocumentError = object

export class ApplyDocumentErrorIdMismatch implements ApplyDocumentError {
  idMismatches: PaxCheckIdMismatches;

  constructor(idMismatches: PaxCheckIdMismatches) {
    this.idMismatches = idMismatches;
  }
}

export class ApplyDocumentErrorSignalsMismatch implements ApplyDocumentError {
  fields: Array<string>;

  constructor(fields: Array<string>) {
    this.fields = fields;
  }
}

export class ApplyDocumentErrorProvidePassportFirst
  implements ApplyDocumentError {}

export class ApplyDocumentErrorRulesMismatch implements ApplyDocumentError {
  rulesMismatches: Array<PaxCheckRulesMismatch>;

  constructor(rulesMismatches: Array<PaxCheckRulesMismatch>) {
    this.rulesMismatches = rulesMismatches;
  }
}

export class ApplyDocumentErrorNoApplicableItems
  implements ApplyDocumentError {}

export class ApplyDocumentErrorRecognitionFailed implements ApplyDocumentError {
  recognitionError: PaxCheckRecognizeDocumentError;

  constructor(recognitionError: PaxCheckRecognizeDocumentError) {
    this.recognitionError = recognitionError;
  }
}

export class ApplyDocumentErrorWrapper {
  error: ApplyDocumentError;
  analyticsParams: { [key: string]: any };

  constructor(
    error: ApplyDocumentError,
    analyticsParams: { [key: string]: any }
  ) {
    this.analyticsParams = analyticsParams;
    this.error = error;
  }

  static fromPaxCheckApplyDocumentError(
    err: PaxCheckApplyDocumentError
  ): ApplyDocumentErrorWrapper {
    const [error, analyticsParams] = applyDocumentErrorFromApi(err);
    return new ApplyDocumentErrorWrapper(error, analyticsParams);
  }

  static fromPaxCheckRecognizeDocumentError(
    err: PaxCheckRecognizeDocumentError
  ): ApplyDocumentErrorWrapper {
    return new ApplyDocumentErrorWrapper(
      new ApplyDocumentErrorRecognitionFailed(err),
      {
        recognition_error: 1,
      }
    );
  }
}

export default ApplyDocumentError;
